export function getInitials(name: string): string {
  if (!name) return '';
  
  const words = name.trim().split(/\s+/);
  let initials = '';

  if (words.length >= 2) {
    // Get first letter of first and last word
    initials = words[0][0] + words[words.length - 1][0];
  } else if (words.length === 1) {
    // If only one word, take first two letters
    initials = words[0].substring(0, 2);
  }

  return initials.toUpperCase();
}

export function getInitialsColor(name: string): string {
  const colors = [
    'bg-blue-100 text-blue-600',
    'bg-green-100 text-green-600',
    'bg-purple-100 text-purple-600',
    'bg-yellow-100 text-yellow-600',
    'bg-pink-100 text-pink-600',
    'bg-indigo-100 text-indigo-600'
  ];
  
  // Use string hash to consistently pick a color
  const hash = name.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  
  return colors[Math.abs(hash) % colors.length];
}